import styled, {css} from 'styled-components'
import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'

export const StyledExportRiaDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

export const StyledExportRiaDialogFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        justify-content: flex-end;
    `
)

export const StyledExportRiaFieldRow = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${spacing * 3}px;
        align-items: start;
    `
)

export const StyledExportRiaDisabledSubmitTooltipTarget = styled.span`
    display: inline-flex;
    cursor: not-allowed;

    & > button:disabled {
        pointer-events: none;
    }
`

export const StyledExportRiaErrorBox = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 3}px ${spacing * 4}px;
        border-radius: 8px;
        background: ${palette.danger[50]};
        border: 1px solid ${palette.danger[200]};
        color: ${palette.danger[700]};

        & svg {
            flex-shrink: 0;
        }
    `
)
